var styleDataHash = "6c507188";
const injectCss = () => {
  var css = `@charset "UTF-8";.YjNRn,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.oGE61{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px;justify-content:center}[dir] .oGE61{background:transparent;border:0;cursor:pointer;padding:4px}[dir] .oGE61:hover:not([disabled]){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.oGE61._9VbcI{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}[dir] .oGE61._9VbcI{background-color:rgba(var(--ricos-action-color-fallback-tuple,2,97,255),.1)}.oGE61._9VbcI svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.oGE61.AD-cf{opacity:.4}[dir] .oGE61.AD-cf{cursor:default}[dir] .oGE61.aRngP:not(._9VbcI):hover{background-color:unset}.oGE61:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.-v66a{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}.-v66a.hUxnc{height:32px;width:32px}.n0vOJ{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var ToolbarButton_default = {
  "fontElementMap": "YjNRn",
  "toolbarButtonWrapper": "oGE61",
  "active": "_9VbcI",
  "disabled": "AD-cf",
  "mobileToolbarButtonWrapper": "aRngP",
  "toolbarButton": "-v66a",
  "mobileToolbarButton": "hUxnc",
  "iconTextWrapper": "n0vOJ"
};
export {
  ToolbarButton_default as default,
  injectCss
};
//# sourceMappingURL=ToolbarButton-scss.js.map
